/**
 * API Enums - Backend enum definitions for v2 API
 * 
 * These enums match the backend values exactly. Used for type safety
 * when working with v2 API enrichment fields.
 * 
 * @feature 011-patient-lifecycle-permissions
 */

/**
 * Patient lifecycle states from v2 API enrichment.
 * Determines which actions (edit, delete, request correction) are available.
 */
export enum PatientLifecycleState {
  /** Patient created, no diagnosis file uploaded yet */
  DRAFT = 'DRAFT',
  
  /** Diagnosis file uploaded, pending review by rettX team */
  UNDER_REVIEW = 'UNDER_REVIEW',
  
  /** Diagnosis rejected or requires additional information */
  MORE_INFO_REQUIRED = 'MORE_INFO_REQUIRED',
  
  /** Diagnosis verified, patient part of registry */
  CONFIRMED = 'CONFIRMED',
  
  /** Identity cryptographically locked (admin action) */
  LOCKED = 'LOCKED'
}

/**
 * Reason codes explaining why patient is in current lifecycle state.
 * Used for detailed messaging in the UI.
 */
export enum PatientLifecycleReasonCode {
  /** No specific reason */
  NONE = 'NONE',
  
  /** Waiting for diagnosis validation */
  DIAGNOSIS_PENDING = 'DIAGNOSIS_PENDING',
  
  /** Validation process failed */
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  
  /** Diagnosis has been confirmed */
  DIAGNOSIS_CONFIRMED = 'DIAGNOSIS_CONFIRMED',
  
  /** Identity has been locked by admin */
  IDENTITY_LOCKED = 'IDENTITY_LOCKED',
  
  /** Missing required information in report */
  MISSING_INFO = 'MISSING_INFO',
  
  /** Information mismatch detected */
  INFO_MISMATCH = 'INFO_MISMATCH'
}

/**
 * Reason codes explaining why a capability is disabled.
 * Maps directly to translation keys for user-friendly messages.
 */
export enum CapabilityReasonCode {
  /** No restriction - capability is allowed */
  NONE = 'NONE',
  
  /** Patient is locked, no modifications allowed */
  PATIENT_LOCKED = 'PATIENT_LOCKED',
  
  /** User doesn't have sufficient access level */
  INSUFFICIENT_ACCESS = 'INSUFFICIENT_ACCESS',
  
  /** Patient has confirmed diagnosis */
  DIAGNOSIS_CONFIRMED = 'DIAGNOSIS_CONFIRMED',
  
  /** Patient is under review */
  UNDER_REVIEW = 'UNDER_REVIEW',
  
  /** Action not available in current state */
  NOT_AVAILABLE = 'NOT_AVAILABLE'
}
